import * as JobInterface from "~/interface/Job";
import _ from "lodash";
import { slimJobItemsForPersist } from "~/utils/slimJobItems";



 

export default class JobBuilder {


    private job: JobInterface.JobCard;

    constructor() {
        this.job  = {
            v : 'app2'
        }
        return this;
    }

    

    withJson2(json2) {
        this.job.json2 = json2;
        return this;
    }

    withMode(mode) {
        this.job.mode = mode;
        return this;
    }

    withSource(source: string) {
        this.job.source = source;
        return this;
    }


    withTableAlias(table: string) {
        this.job.alias = table.replace('โต๊ะ ','T').replace('Table ','T')
        return this;
    }
    withTableUuid(uuid) {
        this.job.uuid = uuid;
        return this;
    }
    withNickName(nickName) {
        this.job.nickName = nickName;
        return this;
    }
    

    // ใช้ตอนย้าย
    withNewTable(newTable) {
        this.job.newAlias = newTable?.replace('โต๊ะ ','T').replace('Table ','T');
        return this;
    }


    withActionType(actionType) {
        this.job.type = actionType;
        this.job.title =  JobInterface.JobActionToString[actionType]
        return this;
    }


    withOrderJson(order) {
        this.job.json =  JSON.stringify(order);
        return this;
    }


    withNote(note) {
        this.job.note = note;
        return this;
    }


    withValue(value) {

        this.job.value = value;
        return this;

    }

    withGuests(guests = 2) {

        this.job.guests = guests;
        return this;
    }

    withEmployee(employee) {

        this.job.employee = {
            name: employee.name || "unknown",
            employeeId: employee.id || "unknown",
        } //_.sample(tmp)
        return this;
    }

    withPrint(bool) {
        this.job.toKitchen = bool;
        return this;
    }
    withIsMoveAndOpeningNewTable(bool) {
        this.job.isMoveAndOpeningNewTable = bool;
        return this;
    }

    withIsOpeningTable(bool) {
        this.job.isOpeningTable = bool;
        return this;
    }

    withIsClosingTable(bool) {
        this.job.isClosingTable = bool;
        this.job.isPayAll = bool;
        return this;
    }


    withJobId(jobId) {
        this.job.jobId = jobId;
        return this;
    }

    withCustom(payload) {

        this.job = {
            ...this.job,
            ...payload
        }
        return this;

    }

    withDeliveryInfo(payload: any) {
        this.job.deliveryInfo = payload;
        return this;
    }

    withJobIdAndTimestamp(timestampISOString) {
        this.job.jobId = timestampISOString
        this.job.timestamp = timestampISOString
        return this;
    }

    withCashInitalAmount(cashInitalAmount: any) {
        this.job.cashInitalAmount = cashInitalAmount;
        return this;
    }

    build() {
        
        let job = _.cloneDeep(this.job)

        job.jobId = job.jobId + ('__' + (job.alias || job.title ))

        // Single choke point for every card that ships __items (PAY / VOID /
        // comment / discount / split / move). Trim it down to the fields a
        // consumer actually reads, and for PAY keep only open-menu rows — the
        // replay engine rebuilds tables from json/json2, so the rest is dead
        // weight on every drop-chain reload. Empty arrays are dropped by the
        // omitBy below. See utils/slimJobItems.ts.
        if (Array.isArray((job as any).__items)) {
            (job as any).__items = slimJobItemsForPersist(job.type, (job as any).__items)
        }

        let _job1 = _.omitBy(job, (value) => {
            if (_.isString(value)) {
                return value.trim() === "";
            }
            if (_.isObject(value)) {
                return _.isEmpty(value);
            }
            return _.isUndefined(value);
        });




        //clean falsty properties job
        // let _job1 = _.omitBy(job, _.isEmpty );
        // let _job2 = _.pickBy(job, _.isNumber );


        return {
            ..._job1,

        };

    }




}
